// Central pricing configuration — single source of truth for all copy.
export const FREE_DAILY_LIMIT = 3;

// Launch mode — flips CTAs between "Reserve pre-launch deal" (waitlist) and real Play Billing
export const LAUNCH_MODE = (process.env.REACT_APP_LAUNCH_MODE || "prelaunch").toLowerCase();
export const IS_PRELAUNCH = LAUNCH_MODE === "prelaunch";
export const IS_LAUNCHED = LAUNCH_MODE === "launched";

export const PRICING = {
  monthly: {
    price: "$2.99",
    priceNumber: 2.99,
    period: "/month",
    label: "$2.99/month",
  },
  yearly: {
    price: "$5.99",
    priceNumber: 5.99,
    period: "/year",
    label: "$5.99/year",
    perMonth: "less than $0.50/month",
  },
  promo: {
    headline: "🔥 Limited Pre-Launch Offer: Get 1 Year of PRO for just $5.99",
    subtext: "3 free checks/day · Unlimited with PRO. Limited time only.",
    cta: "Unlock PRO",
    shortUrgency: "Limited time: Get 1 year for $5.99",
    badge: "Limited Time",
    freeVsPro: "Free: 3 checks/day · PRO: Unlimited",
  },
  featuresShort: [
    "Unlimited message rewrites (Free: 3/day)",
    "Full conversation fixes",
    "Conflict Score tracking",
    "Learns your communication style",
    "Real-time warning system",
    "Advanced tone controls",
    "Saved message history",
  ],
};
